(function () { 
angular.module('invesfleet')
    .directive('validate', validate);

    validate.$inject = [];

    function validate() {
        
        return {
            restrict: 'A',
            scope: {
                ngModel: '@'
            },
            link: function(scope, element, attrs){

                $(document).on('validate-error', function () {
                    if (!element.validity.valid) { //validity.valid = true if all validity.attributes = false

                        if (element.validity.badInput) {
                            //Browser unable to convert the input
                            $(element).addClass('error error-bad-input');
                        }
                        if (element.validity.customError) {
                            //element's custom validity message has been set to a non-empty string by calling the element's setCustomValidity() method.
                            $(element).addClass('error error-custom-error');
                        }
                        if (element.validity.patternMismatch) {
                            //pattern attribute does not match
                            $(element).addClass('error error-pattern-mismatch');
                        }
                        if (element.validity.rangeOverflow) {
                            //max < input
                            $(element).addClass('error error-range-overflow');
                        }
                        if (element.validity.rangeUnderflow) {
                            //min > input
                            $(element).addClass('error error-range-underflow');
                        }
                        if (element.validity.stepMismatch) {
                            //pattern attribute does not match
                            $(element).addClass('error error-step-mismatch');
                        }
                        if (element.validity.tooLong) {
                            //maxlength < input.length
                            $(element).addClass('error error-too-long');
                        }
                        if (element.validity.tooShort) {
                            //minLength > input.length
                            $(element).addClass('error error-too-short');
                        }
                        if (element.validity.typeMismatch) {
                            //type = email || type = url and does not match the input
                            $(element).addClass('error error-type-mismatch');
                        }
                        if (element.validity.valueMissing) {
                            //required but no value
                            $(element).addClass('error error-value-missing');
                        }
                    }
                    
                });

            }
        };
    }
})();